// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"1fd3c342","488":"ebb2b433","595":"63e47d34"}[chunkId] + ".chunk.js";
};